const server = [{
	path: '/server',
	name: 'server',
	component: () => import('views/server/index.vue'),
	children: [
		//挂号
		{
			path: 'register',
			name: 'register',
			component: () => import('views/server/register/index.vue'),
			// component: () => import('views/server/register/department.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//医生信息
		{
			path: 'docList',
			name: 'docList',
			component: () => import('views/server/register/docList.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//选择医生
		{
			path: 'selectDoctor',
			name: 'selectDoctor',
			component: () => import('views/server/register/selectDoctor.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//选择时间段
		{
			path: 'selectTime',
			name: 'selectTime',
			component: () => import('views/server/register/selectTime.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 问卷调查(旧)
		{
			path: "question",
			name: "question",
			component: () => import("views/server/outpatient/question.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 问卷调查(新-选项页)
		{
			path: "selectQuestionType",
			name: "selectQuestionType",
			component: () => import("views/server/outpatient/index.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 问卷调查(新-详情页面)
		{
			path: "questionnaire",
			name: "questionnaire",
			component: () => import("views/server/outpatient/questionnaire.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//挂号列表
		{
			path: 'detairegitelList',
			name: 'detailList',
			component: () => import('views/server/register/detailList.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},

		//挂号详情
		{
			path: 'details',
			name: 'details',
			component: () => import('views/server/register/details.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//挂号详情
		{
			path: 'success',
			name: 'success',
			component: () => import('views/server/register/success.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//缴费列表
		{
			path: 'payList',
			name: 'payList',
			component: () => import('views/server/pay/payList.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//缴费详情
		{
			path: 'payDetails',
			name: 'payDetails',
			component: () => import('views/server/pay/payDetails.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 医保支付页面
		{
			path: 'onlineInsurancePay',
			name: 'onlineInsurancePay',
			component: () => import('views/server/pay/onlineInsurancePay.vue'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		  },
		  {
			path: 'authFail',
			name: 'authFail',
			component: () => import('views/server/pay/authFail.vue'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		  },
		  {
			path: 'onlineInsuranceStatus',
			name: 'onlineInsuranceStatus',
			component: () => import('views/server/pay/onlineInsuranceStatus.vue'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		  },
		//医保缴费详情
		{
			path: 'socPay',
			name: 'socPay',
			component: () => import('views/server/pay/socPay.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//医保缴费失败
		{
			path: "paymentFailList",
			name: "paymentFailList",
			component: () => import("views/server/pay/paymentFailList.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		//缴费成功页
		{
			path: 'paySuccess',
			name: 'paySuccess',
			component: () => import('views/server/pay/paySuccess.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//挂号记录列表页
		{
			path: 'registerList',
			name: 'registerList',
			component: () => import('views/server/register/registerList.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//挂号记录详情页
		{
			path: 'registerDetail',
			name: 'registerDetail',
			component: () => import('views/server/register/registerDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//报告列表
		{
			path: 'reportList',
			name: 'reportList',
			component: () => import('views/server/report/index.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		{
			path: 'reportDetail',
			name: 'reportDetail',
			component: () => import('views/server/report/reportDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		{
			path: 'cheackUpDetail',
			name: 'cheackUpDetail',
			component: () => import('views/server/report/cheackUpDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		{
			path: 'cheackOutDetail',
			name: 'cheackOutDetail',
			component: () => import('views/server/report/cheackOutDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//已缴费详情
		{
			path: 'paidDetail',
			name: 'paidDetail',
			component: () => import('views/server/pay/paidDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//发票列表查询
		{
			path: "invoice",
			name: "invoice",
			component: () => import("views/server/invoice/index.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//发票二维码查询
		{
			path: "invoiceQRcode",
			name: "invoiceQRcode",
			component: () => import("views/server/invoice/invoiceQRcode.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 住院 每日清单
		{
			path: "dailyList",
			name: "dailyList",
			component: () => import("views/server/hospital/dailyList.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 住院 - 押金补缴
		{
			path: "depositPay",
			name: "depositPay",
			component: () => import("views/server/hospital/depositPay/index.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//押金补缴记录
		{
			path: 'depositRecord',
			name: 'depositRecord',
			component: () => import('views/server/hospital/depositPay/record.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 住院 - 押金补缴详情
		{
			path: "depositDetail",
			name: "depositDetail",
			component: () => import("views/server/hospital/depositPay/details.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 住院 - 押金补缴详情
		{
			path: "depositDetail",
			name: "depositDetail",
			component: () => import("views/server/hospital/depositPay/details.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 住院 住院登记
		{
			path: "zhuyuanRegistration",
			name: "zhuyuanRegistration",
			component: () => import("views/server/hospital/zhuyuanRegistration/index.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 住院 住院登记 补录信息
		{
			path: "collectionInfo",
			name: "collectionInfo",
			component: () => import("views/server/hospital/zhuyuanRegistration/collectionInfo.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 住院 住院清单
		{
			path: "zhuyuanSettleList",
			name: "zhuyuanSettleList",
			component: () => import("views/server/hospital/zhuyuanSettleList/zhuyuanSettleList.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		{
			path: "zhuyuanListSearch",
			name: "zhuyuanListSearch",
			component: () => import("views/server/hospital/zhuyuanSettleList/zhuyuanListSearch.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		{
			path: "zhuyuanListDetail",
			name: "zhuyuanListDetail",
			component: () => import("views/server/hospital/zhuyuanSettleList/zhuyuanListDetail.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 住院 医保结算清单
		{
			path: "socialSettleList",
			name: "socialSettleList",
			component: () => import("views/server/hospital/socialSettleList/socialSettleList.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 住院 医保结算清单详情
		{
			path: "socListDetail",
			name: "socListDetail",
			component: () => import("views/server/hospital/socialSettleList/socListDetail.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 住院 出院结算
		{
			path: "outHospitalSettlement",
			name: "outHospitalSettlement",
			component: () => import("views/server/hospital/outHospitalSettlement/outHospitalSettlement.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// //家庭医生
		// {
		//   path: 'familyDoc',
		//   name: 'familyDoc',
		//   component: () => import('views/server/familyDoc/familyDoctor/index.vue'),
		//   meta: {
		//     child: true,
		//     showtabbarfalse: true,
		//     login: true
		//   }
		// },
		// //专家介绍选择科室
		{
			path: 'expertSelectDept',
			name: 'expertSelectDept',
			component: () => import('views/server/expert/expertSelectDept.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// //医生介绍选择医生
		{
			path: 'expertSelectDoctor',
			name: 'expertSelectDoctor',
			component: () => import('views/server/expert/expertSelectDoctor.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// //本院专家介绍选择医生
		{
			path: 'expertSelectDoctor2',
			name: 'expertSelectDoctor2',
			component: () => import('views/server/expert/expertSelectDoctor2.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// //帮扶专家介绍选择医生
		{
			path: 'expertSelectDoctor3',
			name: 'expertSelectDoctor3',
			component: () => import('views/server/expert/expertSelectDoctor3.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// //专家介绍详情
		{
			path: 'expertDetail',
			name: 'expertDetail',
			component: () => import('views/server/expert/expertDetail.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// //专家介绍详情
		{
			path: 'expertDetail2',
			name: 'expertDetail2',
			component: () => import('views/server/expert/expertDetail2.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		//医院动态
		{
			path: 'hospitalNews',
			name: 'hospitalNews',
			component: () => import('views/server/hospitalNews/hospitalNews.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 体检缴费
		{
			path: 'physicalExamination',
			name: 'physicalExamination',
			component: () => import('views/server/examinationFee/index.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 体检缴费详情
		{
			path: 'physicalDetails',
			name: 'physicalDetails',
			component: () => import('views/server/examinationFee/physicalDetails.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},

		// 体检缴费成功页面
		{
			path: 'exaPaySuccess',
			name: 'exaPaySuccess',
			component: () => import('views/server/examinationFee/exaPaySuccess.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 体检已缴费记录
		{
			path: "recordDetails",
			name: "recordDetails",
			component: () => import("views/server/examinationFee/recordDetails.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},
		// 科室简介
		{
			path: 'deptList',
			name: 'deptList',
			component: () => import('views/server/deptList/index.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		// 体检报告
		{
			path: 'physicalExaminationReport',
			name: 'physicalExaminationReport',
			component: () => import('views/server/physicalExaminationReport/index.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		{
			path: "authorization",
			name: "authorization",
			component: () => import("views/server/authorization/index.vue"),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true,
			},
		},

	],
	meta: {}
},
{
	path: '/server/familyDoctor',
	name: 'familyDoctor',
	component: () => import('views/server/familyDoc/familyDoctor/index'),
	children: [{
		path: '',
		redirect: '/server/familyDoctor/person'
	},
	{
		path: '/server/familyDoctor/person',
		name: 'familyDoctorPerson',
		component: () => import('views/server/familyDoc/familyDoctor/person'),
		meta: {
			title: '个人基本信息表',
			showtabbarfalse: true,
			child: true
		}
	},
	{
		path: '/server/familyDoctor/health',
		name: 'familyDoctorHealth',
		component: () => import('views/server/familyDoc/familyDoctor/health'),
		meta: {
			title: '个人基本信息表',
			showtabbarfalse: true
		}
	},
	{
		path: '/server/familyDoctor/live',
		name: 'familyDoctorLive',
		component: () => import('views/server/familyDoc/familyDoctor/live'),
		meta: {
			title: '个人基本信息表',
			showtabbarfalse: true
		}
	}
	]
}];

export default server;
